module.exports = __webpack_public_path__ + "static/media/[Professor_Teas]2014-11-10.d8f4d47a.md";